export default __webpack_public_path__ + "locales/ro/Webhooks.json?hash=6f19c0869947d014539018f465b57ba0";